<template>
  <div
    class="r-ipt common-flex common-justify-between"
    :style="{ width: width + 'px' }"
  >
    <div class="title">
      {{ config.label }}
      <span style="color: red" v-if="config.must">*</span>
    </div>
    <AutoComplete
      v-model="config.customerName"
      transfer
      :disabled="disabled"
      placeholder=""
      clearable
      @on-clear="handleClear"
      @on-search="config.remoteMethod"
      @on-select="handleChange"
    >
      <Option
        v-for="item in config.list"
        :value="item.custName"
        :key="item.id"
        >{{ item.custName }}</Option
      >
    </AutoComplete>
  </div>
</template>

<script>
export default {
  name: "r-ipt",
  data() {
    return {};
  },
  /*label 标题
    must 是否必填,
    type 类型,
    inputvalue  输入数据
  */
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    config: Object,
    width: {
      type: [Number, String],
      default: 350
    }
  },
  methods: {
    handleChange(custName) {
      let custItem = this.config.list.find(item => {
        return item.custName === custName;
      });
      this.$emit("change", custItem);
    },
    handleClear() {
      this.$set(this.config, "list", []);
      this.$set(this.config, "customerName", null);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.r-ipt {
  // width: 350px;
  padding-bottom: 2px;
  border-bottom: 0.5px solid #666666;
  .title {
    // width: 300px;
    line-height: 32px;
    flex-basis: 128px;
  }
  /deep/.ivu-input {
    // text-align: right;
    width: 100%;
    height: 32px;
    line-height: 32px;
    box-sizing: border-box;
    // text-align: right;
    // padding-right: 5px;
    text-align: center;
    background: #f8fafe;
    border-radius: 4px;
    border: none;
    font-weight: 500;
    line-height: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-autocomplete.vue